export const ADD_ONS_PAGE = '/dashboard/add-ons';
export const ORDERS_PAGE = '/dashboard/add-ons/orders';
